<div [ngClass]="theme">
  <div class="mat-app-background route-container" style="min-height: 100dvh">
    <router-outlet></router-outlet>
  </div>
</div>
<app-check-cookies-support></app-check-cookies-support>
<app-debug></app-debug>
<div id="user-guide-container"></div>
